import React from 'react';

import usePreCompCurriculumDropdown from './UsePreCompCurriculumDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PreCompCurriculumDropdown = ({ label, name, value, error, message, onChange }) => {
  const { preCompCurriculumState } = usePreCompCurriculumDropdown();

  return preCompCurriculumState.message
    ? <span className={global.LoadingMsg}>{preCompCurriculumState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={preCompCurriculumState.dataAsOptionsWithNames}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={preCompCurriculumState.isLoading}
      />
    );
};

export default PreCompCurriculumDropdown;